// extracted by mini-css-extract-plugin
export default {"justify-navbar":"NavbarAdmin_justify-navbar__cIfxA","list-notification":"NavbarAdmin_list-notification__TWW1X"};